import { HeaderUI } from "./HeaderUI";
import { StandardProps } from "../componentMap";

export const Header = ({
  runtimeConfig,
}: Pick<StandardProps, "runtimeConfig">) => {
  const { esiBasepath } = runtimeConfig;
  const srcUrl = `${esiBasepath}/scaffold/header.html?includeCoreCSS=false&includeCoreJS=false&includePolyfills=false`;

  return <HeaderUI srcUrl={srcUrl} />;
};
